import moment from 'moment';
import Swal from 'sweetalert2'
import add_office from './AddOffice/AddOffice.vue';
import edit_office from './EditOffice/EditOffice.vue';
export default {
    name: 'Offices',
    components: {
        'add-office': add_office,
        'edit_office': edit_office

    },
    created() {
        window.scrollTo(0, 0);
        this.GetAllMunicipalities();
        this.GetOffices(this.pageNo);
        this.UserData = this.$store.getters.getUserData
        if (this.UserData.userType != 1 && this.UserData.userType != 4)
        {
            window.location.href = "/";
        }
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            Municipalities: [],
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            MunicipalityId: '',
            Offices: [],
            OfficeId: null,
            UserData:null
        };
    },
    methods: {
        Edit(Id) {
            this.state = 2;
            this.OfficeId = Id
        },
        DeactivateOffice(UserId) {


            this.$confirm('سيؤدي ذلك إلى ايقاف تفعيل المكتب  . استمر؟', 'تـحذير', {
                confirmButtonText: 'نـعم',
                cancelButtonText: 'لا',
                type: 'warning'
            }).then(() => {


                this.$http.DeactivateOffice(UserId)
                    .then(() => {
                        if (this.Offices.lenght === 1) {
                            this.pageNo--;
                            if (this.pageNo <= 0) {
                                this.pageNo = 1;
                            }
                        }
                        this.$message({
                            type: 'info',
                            message: 'تم ايقاف التفعيل المكتب بنجاح',
                        });
                        this.GetOffices(this.pageNo);
                    })
                    .catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.response.data
                        });
                    });
            });
        },
        ActivateOffice(UserId) {

            this.$confirm('سيؤدي ذلك إلى تفعيل المكتب  . استمر؟', 'تـحذير', {
                confirmButtonText: 'نـعم',
                cancelButtonText: 'لا',
                type: 'warning'
            }).then(() => {


                this.$http.ActivateOffice(UserId)
                    .then(() => {
                        if (this.Offices.lenght === 1) {
                            this.pageNo--;
                            if (this.pageNo <= 0) {
                                this.pageNo = 1;
                            }
                        }
                        this.$message({
                            type: 'info',
                            message: 'تم تفعيل المكتب بنجاح',
                        });
                        this.GetOffices(this.pageNo);
                    })
                    .catch((err) => {
                        this.$message({
                            type: 'error',
                            message: err.response.data
                        });
                    });
            });

        },


        RemoveOffice(Id) {
            Swal.fire({
                title: 'هل حقا تريد مسح بيانات المكتب؟',
                text: "لن نتمكن من استرجاع البيانات لاحقا !!",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'رجـوع',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'اسـتمر,نعم'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteOffice(Id)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.$notify({
                                title: 'تم المسح بنجاح',
                                dangerouslyUseHTMLString: true,
                                message: '<strong>' + response.data + '</strong>',
                                type: 'success'
                            });
                            this.GetOffices(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$message({
                                type: 'error',
                                message: err.response.data
                            });
                        });
                }
            });
        },


        GetOffices(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }
            this.$blockUI.Start();
            this.$http.GetOffices(this.MunicipalityId,this.pageNo, this.pageSize)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Offices = response.data.offices;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pages = 0;
                });

        },

        GetAllMunicipalities() {
            this.$blockUI.Start();
            this.$http.GetAllMunicipalities()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.municipalities;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },
        AddOffice() {
            this.state = 1;
        },
    }    
}
